import { useNavigate } from "react-router-dom"
import FullScreenLayout from "../../../components/FullScreenLayout"
import { useAuth } from "../../../utils/context/AuthContext"
import { usePatients } from "../../../utils/context/PatientsContext"
import { ExpertRole } from "../../../utils/Enums"
import { useGetNutritionists } from "../../experts/hooks/useGetNutritionists"
import { useGetPhysicians } from "../../experts/hooks/useGetPhysicians"
import { AdminFilters, PatientCard, SearchBox, SubscriptionFilter } from "../components"
import { usePatientFilters } from "../hooks/usePatientFilters"

const Customers = () => {
  const { auth } = useAuth()
  const role = auth.role
  const { patientsState } = usePatients()
  const patients = patientsState.patients
  const { nutritionists } = useGetNutritionists()
  const { physicians } = useGetPhysicians()

  const navigate = useNavigate()

  const {
    filters,
    filteredPatients,
    setSearchTerm,
    setSelectedNutritionist,
    setSelectedPhysician,
    setSelectedSubscriptionFilter,
    resetFilters,
    hasActiveFilters,
  } = usePatientFilters(patients)

  const handleNutritionistSelect = (name: string, email: string) => {
    setSelectedNutritionist(email)
  }

  const handlePhysicianSelect = (name: string, email: string) => {
    setSelectedPhysician(email)
  }

  const handleResetNutritionists = () => {
    setSelectedNutritionist(null)
  }

  const handleResetPhysicians = () => {
    setSelectedPhysician(null)
  }

  const handlePatientClick = (patientId: string) => {
    navigate(`single-customer?patient_id=${patientId}`)
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value)
  }

  const handleSubscriptionFilterChange = (filter: string) => {
    setSelectedSubscriptionFilter(filter)
  }

  return (
    <FullScreenLayout title="Clienti">
      <div className="w-full flex flex-col space-y-[40px]">
        {/* Search and Filters Row */}
        <div className="w-full rounded-[5px] shadow-platform border border-solid border-border px-[20px] py-[30px]">
          <div className="w-full flex flex-col lg:flex-row lg:items-start lg:space-x-8 space-y-6 lg:space-y-0">
            {/* Search Section */}
            <div className="flex-1">
              <SearchBox
                searchTerm={filters.searchTerm}
                onSearchChange={handleSearchChange}
                compact={true}
              />
            </div>
            
            {/* Admin Filters Section */}
            {role === ExpertRole.Admin && (
              <div className="flex-1">
                <AdminFilters
                  nutritionists={nutritionists}
                  physicians={physicians}
                  selectedNutritionist={filters.selectedNutritionist}
                  selectedPhysician={filters.selectedPhysician}
                  onNutritionistSelect={handleNutritionistSelect}
                  onPhysicianSelect={handlePhysicianSelect}
                  onResetNutritionists={handleResetNutritionists}
                  onResetPhysicians={handleResetPhysicians}
                  totalPatients={filteredPatients.length}
                  compact={true}
                />
              </div>
            )}
          </div>
        </div>
        
        {/* Subscription Filter */}
        <SubscriptionFilter
          patients={patients}
          selectedFilter={filters.selectedSubscriptionFilter}
          onFilterChange={handleSubscriptionFilterChange}
        />
        
        <div className="w-full h-[1px] bg-black" />
        
        <div className="space-y-[20px]">
          {/* <PatientsHeader /> */}
          <div className="w-full flex-1 space-y-[20px]">
            {filteredPatients.length > 0 ? (
              filteredPatients.map((patient, index) => (
                <PatientCard
                  key={patient.user_id || index}
                  patient={patient}
                  onClick={() => handlePatientClick(patient.user_id)}
                />
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                Nessun cliente trovato
              </div>
            )}
          </div>
        </div>
      </div>
    </FullScreenLayout>
  )
}

export default Customers
